import {
  faSortDown,
  faSortUp,
  faTrash
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react';
import moment from 'moment';
import { useContext, useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import { storesContext } from '../../../../stores/storesContext';
import ConfirmationModal from '../../../helpers/ConfirmationModal';
import { errorToast, successToast } from '../../../helpers/toasts/ToastUtils';
import UpdateSprayDataModal from './UpdateSprayDataModal';

const SprayDataTable = ({ selectedBlock }) => {
  const userStore = useContext(storesContext);
  const alcmStore = userStore.alcmStore;

  const [sortOrder, setSortOrder] = useState('asc'); // 'desc' | 'asc'.

  const columns = [
    {
      title: (
        <>
          Date
          <Button
            variant='link'
            size='sm'
            className='p-0 ml-2'
            onClick={() => {
              if (sortOrder === 'desc') setSortOrder('asc');
              else setSortOrder('desc');
            }}
          >
            {sortOrder === 'desc' ? (
              <FontAwesomeIcon icon={faSortDown} />
            ) : (
              <FontAwesomeIcon icon={faSortUp} />
            )}
          </Button>
        </>
      )
    },
    { title: 'Product Name' },
    { title: 'Type' },
    { title: 'Efficacy Days' },
    { title: '', style: { width: '10%' } }
  ];

  const data = (selectedBlock.alcm_spray_data || []).slice().sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);

    return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
  });

  const parseSprayType = (type) => {
    if (type === 'insecticide') return 'Insecticide';
    else return 'Plant Growth Regulator';
  };

  return (
    <Table bordered responsive size='sm'>
      <thead>
        <tr>
          {columns.map((column, i) => {
            return (
              <th
                key={`${column.date}-${i}`}
                style={column.style ? column.style : null}
              >
                {column.title}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {data.length === 0 ? (
          <tr>
            <td
              colSpan={columns.length}
              className='text-center text-muted py-3'
            >
              No spray data records
            </td>
          </tr>
        ) : (
          data.map((row) => {
            const date = moment(row.date, 'YYYY-MM-DD').format('YYYY/MM/DD');
            const productName = row.product_name;
            const type = parseSprayType(row.type);
            const efficacyDays = row.efficacy_days;
            return (
              <tr key={row.id}>
                <td>{date}</td>
                <td>{productName}</td>
                <td>{type}</td>
                <td>{efficacyDays}</td>
                <td>
                  <div className='d-flex justify-content-center'>
                    <div className='mr-2'>
                      <UpdateSprayDataModal
                        monitoringBlock={selectedBlock}
                        sprayData={row}
                      />
                    </div>
                    <div>
                      <ConfirmationModal
                        title='Confirm Delete'
                        bodyText='Are you sure you want to delete this spray data record?'
                        confirmAction={() => {
                          return alcmStore
                            .deleteSprayData(row.id, selectedBlock.id)
                            .then(() => {
                              successToast('Successfully deleted spray data');
                            })
                            .catch((error) => {
                              console.error(error);
                              errorToast('Failed to delete spray data');
                            });
                        }}
                        showButton={{
                          children: <FontAwesomeIcon icon={faTrash} />,
                          props: {
                            className: 'text-danger',
                            variant: 'link',
                            size: 'sm'
                          }
                        }}
                        confirmButton={{
                          props: { variant: 'danger' }
                        }}
                      />
                    </div>
                  </div>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </Table>
  );
};

export default observer(SprayDataTable);

